<template>
    <div>
        <a-button @click="visible = true" :disabled="selected.length == 0" class="">Set Goal</a-button>

        <a-button v-if="false" @click="visible = true" class="tw-hidden md:tw-flex" left-icon="heroicons:plus-16-solid">{{
            $t("buttons.create") }}</a-button>
        <a-button v-if="false" @click="visible = true" class="md:tw-hidden" icon="heroicons:plus-16-solid"></a-button>
        <a-popup :visible="visible" @cancel="onCancel">
            <div
                class="tw-mx-auto tw-w-[95%] md:tw-max-w-[800px] tw-overflow-hidden tw-h-fit dark:tw-bg-gray-900 tw-bg-white tw-border tw-border-solid dark:tw-border-gray-400 tw-border-gray-300 tw-shadow-md tw-my-5 tw-rounded">
                <div
                    class="tw-p-4 tw-text-lg tw-border-b tw-border-solid tw-font-medium tw-flex dark:tw-text-gray-700 tw-text-gray-500 tw-items-center tw-gap-4 dark:tw-bg-gray-100 tw-bg-gray-50">
                    {{ $t("common.set-marketers-goal") }}
                </div>

                <div class="tw-p-5 tw-bg-white">
                    <div class="tw-grid tw-grid-cols-12 tw-gap-x-4 tw-gap-y-2">
                        <div v-if="false" class="tw-col-span-12 md:tw-col-span-12">
                            <FormField left-icon="solar:user-circle-bold-duotone" v-model="goal.name" :label="$t('fields.name')" type="text" :error="errors.name &&
                                $t('errors.' + errors.name, {
                                    field: $t('fields.name'),
                                })
                                " />
                        </div>

                        <div class="tw-col-span-12 md:tw-col-span-12">
                            <div class="tw-w-full tw-grid tw-grid-cols-4 tw-gap-2">
                                <button @click="type = 'daily'"   :class="[type == 'daily' && 'tw-bg-primary-500 tw-border-primary-300 tw-text-white hover:tw-bg-primary-500 ']" class="tw-py-2 tw-text-center tw-px-2 tw-border tw-border-solid tw-border-gray-200 tw-rounded tw-font-semibold tw-duration-200 hover:tw-bg-primary-50 hover:tw-border-primary-200 tw-cursor-pointer">Daily</button>
                                <button @click="type = 'weekly'"  :class="[type == 'weekly' && 'tw-bg-primary-500 tw-border-primary-300 tw-text-white hover:tw-bg-primary-500 ']" class="tw-py-2 tw-text-center tw-px-2 tw-border tw-border-solid tw-border-gray-200 tw-rounded tw-font-semibold tw-duration-200 hover:tw-bg-primary-50 hover:tw-border-primary-200 tw-cursor-pointer">Weekly</button>
                                <button @click="type = 'monthly'" :class="[type == 'monthly' && 'tw-bg-primary-500 tw-border-primary-300 tw-text-white hover:tw-bg-primary-500 ']" class="tw-py-2 tw-text-center tw-px-2 tw-border tw-border-solid tw-border-gray-200 tw-rounded tw-font-semibold tw-duration-200 hover:tw-bg-primary-50 hover:tw-border-primary-200 tw-cursor-pointer">Monthly</button>
                                <button @click="type = 'custom'"  :class="[type == 'custom' && 'tw-bg-primary-500 tw-border-primary-300 tw-text-white hover:tw-bg-primary-500 ']" class="tw-py-2 tw-text-center tw-px-2 tw-border tw-border-solid tw-border-gray-200 tw-rounded tw-font-semibold tw-duration-200 hover:tw-bg-primary-50 hover:tw-border-primary-200 tw-cursor-pointer">Custom</button>
                            </div>
                        </div>

                        <div v-if="type == 'custom'" class="tw-col-span-12 md:tw-col-span-12">
                            <FormField left-icon="solar:user-circle-bold-duotone" v-model="goal.start_date" :label="$t('fields.start_date')" type="date" :error="errors.name &&
                                $t('errors.' + errors.name, {
                                    field: $t('fields.name'),
                                })
                                " />
                                
                            <FormField left-icon="solar:user-circle-bold-duotone" v-model="goal.end_date" :label="$t('fields.end_date')" type="date" :error="errors.name &&
                                $t('errors.' + errors.name, {
                                    field: $t('fields.name'),
                                })
                                " />
                        </div>

                        <div class="tw-col-span-12 md:tw-col-span-12">
                            <FormField left-icon="solar:user-circle-bold-duotone" v-model="goal.leads" :label="$t('fields.leads')" type="text" :error="errors.name &&
                                $t('errors.' + errors.leads, {
                                    field: $t('fields.leads'),
                                })
                                " />
                        </div>



                    </div>
                </div>

                <div
                    class="tw-p-4 tw-text-lg tw-border-t tw-justify-end tw-border-solid tw-font-medium tw-flex dark:tw-text-gray-700 tw-text-gray-500 tw-items-center tw-gap-4 dark:tw-bg-gray-100 tw-bg-gray-50">
                    <a-button :disabled="loading" @click="onCancel" class="tw-min-w-[120px]"
                        intent="simple">{{
                            $t("buttons.cancel") }}</a-button>
                    <a-button :disabled="loading" :loading="loading" @click="onSubmit"
                        class="tw-min-w-[120px]">{{
                            $t("buttons.save") }}</a-button>
                </div>
            </div>
        </a-popup>
    </div>
</template>

<script setup>
import { inject, ref } from "vue";
import FormField from "@/components/form/FormField";
// import FormVueSelect from "@/components/form/FormVueSelect";
import users from "@/api/users";
import useAlert from "@/composables/useAlert";

const visible = ref(false);
const loading = ref(false);
const goal = ref({  });
const errors = ref({});
const selected = inject('selected');
const type = ref('daily');

const onCancel = () => {
    errors.value = {}
    visible.value = false;
};

const onSubmit = async () => {
    
    const form = {
        ids: selected.value,
        value: goal.value.leads,
        type: type.value,
        start_date: goal.value.start_date,
        end_date: goal.value.end_date,
    }

    loading.value = true;
    await users.setGoal(form)
    .then(res => {
        if(res.data.code == 'SUCCESS'){
            useAlert('Goal set successfully');
            onCancel();
        }
    })
    .catch(err => {
        console.log(err);
    })
    loading.value = false;
    console.log(form);
    
};
</script>

<style></style>
